import * as $ from 'jquery';
import { Swiper, SwiperOptions } from 'swiper';
import { LarchSys } from '../utils/larchSys';

import 'swiper/swiper-bundle.css';


export function sliderFeature(larchSys: LarchSys) {

    $('[slider]').each((i, element) => {
        const autoPlay = element.hasAttribute('slider-autoplay');
        const name = element.getAttribute('slider');

        initSlider(name, element, autoPlay);
    });

    function initSlider(name: string, element: HTMLElement, autoPlay: boolean) {
        const $element = $(element);

        switch (name) {

            case "header": {

                if ($element.find('.swiper-wrapper').children().length <= 1) {
                    $element.find('.slider-arrows').remove();
                    return;
                }

                const _ = new Swiper($element[0], {
                    // for better swipe / click
                    resistance: true,
                    resistanceRatio: 0.99,

                    // cssMode: true,
                    effect: 'fade',

                    autoplay: +autoPlay ? { delay: +autoPlay } : undefined,
                    loop: true,
                    loopedSlides: 2,

                    fadeEffect: { crossFade: true },

                    navigation: {
                        nextEl: '.slider-next',
                        prevEl: '.slider-prev',
                    }
                });

                break;
            }

            case "packages": {

                if ($element.find('.swiper-wrapper').children().length <= 1) {
                    $element.find('.slider-arrows').remove();
                    return;
                }

                function update(swiper: Swiper) {
                    //console.log(swiper.activeIndex);
                    //if (swiper.activeIndex > 0) {
                    //    $element.css('padding-left', '20px');
                    //}
                    //else {
                    //    $element.css('padding-left', '0');
                    //}
                }

                const _ = new Swiper($element[0], <SwiperOptions>{
                    // for better swipe / click
                    resistance: true,
                    resistanceRatio: 0.99,

                    // slidesPerView: 'auto',

                    // cssMode: true,
                    // effect: 'fade',

                    autoplay: +autoPlay ? { delay: +autoPlay } : undefined,
                    loop: true,
                    loopedSlides: 2,

                    // fadeEffect: { crossFade: true },

                    navigation: {
                        nextEl: '.slider-next',
                        prevEl: '.slider-prev',
                    },

                    pagination: {
                        el: $element.next('.swiper-pagination')[0],
                        clickable: true,
                    },
                    on: {
                        init() {
                            $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                        },
                        slideChange: function () {
                            update(this);
                        }
                    }
                } as Object);

                break;
            }

            case "content": {

                if ($element.find('.swiper-wrapper').children().length <= 1) {
                    $element.find('.slider-arrows').remove();
                    return;
                }

                const _ = new Swiper($element[0], <SwiperOptions>{
                    // for better swipe / click
                    resistance: true,
                    resistanceRatio: 0.99,

                    effect: 'fade',
                    autoplay: +autoPlay ? { delay: +autoPlay } : undefined,
                    loop: true,
                    loopedSlides: 2,

                    // disabled because it produces a fatal BUG in css-grid on fireFox where all slides get extreme big!
                    preloadImages: false,
                    updateOnImagesReady: false,

                    navigation: {
                        nextEl: '.slider-next',
                        prevEl: '.slider-prev',
                    },

                    pagination: {
                        el: $element.find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    on: {
                        init() {
                            $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                        },
                        slideChange() {
                            // update(this);
                        }
                    }
                } as Object);

                break;
            }

            default: {
                console.error(new Error('Slider ' + name + ' not defined!'));
            }
        }
    }
}


/**
 * @param {any} mediaBreakpoint '(max-width: 991px)'
 * @param {{onMatch: function, onUnmatch: function}} obj actions
 */
function media(mediaBreakpoint: string, obj: { onMatch: () => void, onUnmatch: () => void }) {
    var breakpoint = window.matchMedia(mediaBreakpoint);
    var match = false;
    const check = () => {
        if (breakpoint.matches === true) {
            if (!match) {
                obj.onMatch();
                match = true;
            }
        } else if (breakpoint.matches === false) {
            if (match) {
                obj.onUnmatch();
                match = false;
            }
        }
    };
    breakpoint.addListener(check);
    check();
}


export function reinitSlider(element: HTMLElement) {
    var $element = $(element);

    // we need to wait until the browser knows all dimensions.
    requestAnimationFrame(() => {
        if ($element.is('.swiper-container')) {
            reinit($element[0]);
        }
        $element.find(".swiper-container").each((i, element) => {
            reinit(element);
        });

        // force slider to recalculate sizes; is sometimes required
        $(window).trigger('resize');
    });

    function reinit(element: HTMLElement) {
        let swiper = (element as any).swiper as any;
        if (swiper) {
            const options = swiper.passedParams as SwiperOptions;

            swiper.destroy(true, true);

            swiper = new Swiper(element, options as Object);
        }
    }
}
